import { useState } from "react";
import { Mail, Phone, MessageCircle, CheckCircle2 } from "lucide-react";
import { SOCIAL } from "@/data/content";
import { PageHero, Reveal } from "@/components/site/ui";
import { EnquiryForm } from "@/components/site/EnquiryForm";

export default function Contact() {
  const [sent, setSent] = useState(false);
  const info = [[Mail, "Email", SOCIAL.email, `mailto:${SOCIAL.email}`], [Phone, "Phone", SOCIAL.phone, `tel:${SOCIAL.phone}`], [MessageCircle, "WhatsApp", "Chat with our team", SOCIAL.whatsapp]];
  return (
    <div data-testid="contact-page">
      <PageHero eyebrow="Contact" title="We'd love to" highlight="hear from you" text="Confused about which course fits you? Send us a message and a counsellor will guide you, free of cost." />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-12 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5 space-y-4">
          {info.map(([I, l, v, href]) => (
            <Reveal key={l}>
              <a href={href} target="_blank" rel="noreferrer" className="glass neon-card rounded-3xl p-6 flex items-center gap-4">
                <div className="icon-orb"><I size={20} /></div>
                <div><p className="text-xs text-[var(--muted)]">{l}</p><p className="font-semibold">{v}</p></div>
              </a>
            </Reveal>
          ))}
        </div>
        <div className="lg:col-span-7 glass rounded-[2rem] p-8 shadow-[0_0_40px_-14px_var(--glow-pink)]">
          {sent ? (
            <div data-testid="contact-success" className="text-center py-12">
              <CheckCircle2 className="mx-auto text-[var(--pink)]" size={56} />
              <h3 className="font-display text-3xl font-bold mt-4">Message sent!</h3>
              <p className="text-[var(--muted)] mt-2">We'll get back to you within 24 hours.</p>
              <button onClick={() => setSent(false)} className="btn-ghost mt-6" data-testid="contact-send-another">Send another</button>
            </div>
          ) : (
            <>
              <h2 className="font-display text-3xl font-bold">Send a message</h2>
              <EnquiryForm kind="contact" prefix="contact" onDone={() => setSent(true)} />
            </>
          )}
        </div>
      </div>
    </div>
  );
}
